(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lure-glow-sales"] && !Shopify.designMode) return;
  try {
    
  window.addEventListener('pageshow', (event) => {
    if (!document.querySelector('.lure-glow-sales')) return;
    const navigation = performance.getEntriesByType('navigation')[0];
    if (event.persisted || navigation?.type === 'back_forward') window.location.reload();
  });
  document.addEventListener('click', (event) => {
    const section = event.target.closest('.lure-glow-sales');
    if (!section) return;
    const imageButtons = Array.from(section.querySelectorAll('[data-lure-glow-image]'));
    const imageButton = event.target.closest('[data-lure-glow-image]');
    const mainImage = section.querySelector('[id^="LureGlowMainImage-"]');
    if (imageButton && mainImage) {
      mainImage.src = imageButton.dataset.lureGlowImage;
      imageButtons.forEach((button) => button.classList.toggle('is-active', button === imageButton));
    }
    const arrow = event.target.closest('[data-lure-glow-prev],[data-lure-glow-next]');
    if (arrow && mainImage) {
      let index = imageButtons.findIndex((button) => button.classList.contains('is-active'));
      index += arrow.hasAttribute('data-lure-glow-next') ? 1 : -1;
      index = (index + imageButtons.length) % imageButtons.length;
      imageButtons[index].click();
    }
    const bundleButton = event.target.closest('[data-lure-glow-bundle]');
    if (bundleButton) {
      const quantity = section.querySelector('[data-lure-glow-quantity]');
      if (quantity) quantity.value = bundleButton.dataset.lureGlowBundle;
      section.querySelectorAll('[data-lure-glow-bundle]').forEach((button) => {
        button.classList.toggle('is-active', button === bundleButton);
        button.setAttribute('aria-pressed', String(button === bundleButton));
      });
      section.querySelectorAll('.lure-glow-sales__bundle-wrap').forEach((wrap) => wrap.classList.toggle('is-active', wrap.contains(bundleButton)));
    }
    const videoDot = event.target.closest('[data-lure-glow-video]');
    if (videoDot) {
      const videos = section.querySelectorAll('[data-lure-glow-videos] > div');
      const index = Number(videoDot.dataset.lureGlowVideo);
      if (videos[index]) videos[index].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      section.querySelectorAll('[data-lure-glow-video]').forEach((dot) => dot.classList.toggle('is-active', dot === videoDot));
    }
    const reviewButton = event.target.closest('[data-lure-review-prev],[data-lure-review-next]');
    const track = section.querySelector('[data-lure-review-track]');
    if (track && reviewButton) {
      const card = track.querySelector('article');
      const amount = card ? card.offsetWidth + 14 : 420;
      track.parentElement.scrollBy({ left: amount * (reviewButton.hasAttribute('data-lure-review-next') ? 1 : -1), behavior: 'smooth' });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lure-header"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!form.matches('.lure-glow-sales__form, .lumiere-form')) return;
    const drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.renderContents !== 'function') return;
    event.preventDefault();
    if (form.dataset.cartSubmitting === 'true') return;

    const button = form.querySelector('[type="submit"]');
    const error = form.querySelector('[data-lure-cart-error]');
    form.dataset.cartSubmitting = 'true';
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    if (error) error.hidden = true;

    const data = new FormData(form);
    data.delete('return_to');
    data.set('sections', drawer.getSectionsToRender().map((section) => section.id).join(','));
    data.set('sections_url', window.location.pathname);
    drawer.setActiveElement(button);

    try {
      const response = await fetch(window.routes.cart_add_url, {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: data
      });
      const cartData = await response.json();
      if (!response.ok || cartData.status) {
        if (error) {
          error.textContent = typeof cartData.description === 'string' ? cartData.description : error.dataset.lureCartError;
          error.hidden = false;
        }
        return;
      }
      try {
        drawer.classList.remove('is-empty');
        drawer.renderContents(cartData);
      } catch (renderError) {
        // The item was already added: never repeat the POST if section rendering fails.
        window.location.assign(window.routes.cart_url);
        return;
      }
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'lure-product-form', productVariantId: data.get('id'), cartData });
      }
    } catch (requestError) {
      // A lost response may still mean the item was added; inspect the cart rather than add twice.
      window.location.assign(window.routes.cart_url);
    } finally {
      delete form.dataset.cartSubmitting;
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lure-lumiere-sales"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-lumiere-section]').forEach((section) => {
    const thumbs = Array.from(section.querySelectorAll('[data-gallery-index]'));
    const mainImage = section.querySelector('[data-gallery-main]');
    let galleryIndex = 0;

    const selectImage = (index) => {
      if (!mainImage || !thumbs.length) return;
      galleryIndex = (index + thumbs.length) % thumbs.length;
      mainImage.src = thumbs[galleryIndex].dataset.gallerySrc;
      mainImage.srcset = '';
      thumbs.forEach((thumb, thumbIndex) => thumb.classList.toggle('is-active', thumbIndex === galleryIndex));
    };

    thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => selectImage(index)));
    section.querySelector('[data-gallery-prev]')?.addEventListener('click', () => selectImage(galleryIndex - 1));
    section.querySelector('[data-gallery-next]')?.addEventListener('click', () => selectImage(galleryIndex + 1));

    const quantity = section.querySelector('[data-bundle-quantity]');
    section.querySelectorAll('[data-bundle]').forEach((bundle) => {
      bundle.addEventListener('click', () => {
        section.querySelectorAll('[data-bundle]').forEach((item) => item.classList.remove('is-selected'));
        bundle.classList.add('is-selected');
        if (quantity) quantity.value = bundle.dataset.bundle;
      });
    });

    const reviews = section.querySelector('[data-review-track]');
    section.querySelector('[data-review-prev]')?.addEventListener('click', () => reviews?.scrollBy({ left: -404, behavior: 'smooth' }));
    section.querySelector('[data-review-next]')?.addEventListener('click', () => reviews?.scrollBy({ left: 404, behavior: 'smooth' }));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lure-reviews"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[id^="LureReviews-"]');
    roots.forEach((root) => {
      if (root.dataset.ready === 'true') return;
      const track = root.querySelector('[data-track]');
      const cards = Array.from(root.querySelectorAll('.lure-review-card'));
      const previous = root.querySelector('[data-previous]');
      const next = root.querySelector('[data-next]');
      if (!track || !cards.length || !previous || !next) return;
      root.dataset.ready = 'true';
      let index = 0;
      const update = () => {
        const step = cards[0].getBoundingClientRect().width + 14;
        track.style.transform = `translateX(${-index * step}px)`;
      };
      previous.addEventListener('click', () => {
        index = Math.max(index - 1, 0);
        update();
      });
      next.addEventListener('click', () => {
        index = Math.min(index + 1, cards.length - 1);
        update();
      });
      window.addEventListener('resize', update, { passive: true });
      update();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lure-transform"] && !Shopify.designMode) return;
  try {
    

function initLurePresell(root){
 if(root.dataset.initialized)return;root.dataset.initialized='true';
 root.querySelectorAll('.ltp-ds-faq-q').forEach(button=>{const answer=button.nextElementSibling;answer.setAttribute('aria-hidden','true');button.addEventListener('click',()=>{const open=button.getAttribute('aria-expanded')!=='true';button.setAttribute('aria-expanded',String(open));answer.setAttribute('aria-hidden',String(!open));button.parentElement.classList.toggle('active',open);});});
 const slides=[...root.querySelectorAll('.ltp-reviews__mobile-slide')];const dots=[...root.querySelectorAll('.ltp-reviews__dot')];let current=0;
 const show=index=>{current=(index+slides.length)%slides.length;slides.forEach((s,i)=>{s.classList.toggle('is-active',i===current);s.setAttribute('aria-hidden',String(i!==current));});dots.forEach((d,i)=>d.classList.toggle('ltp-reviews__dot--active',i===current));};
 root.querySelector('#ltpRevPrev')?.addEventListener('click',()=>show(current-1));root.querySelector('#ltpRevNext')?.addEventListener('click',()=>show(current+1));dots.forEach((d,i)=>d.addEventListener('click',()=>show(i)));
 const track=root.querySelector('#ltpRevTrack');let startX=0;track?.addEventListener('touchstart',e=>{startX=e.touches[0].clientX;},{passive:true});track?.addEventListener('touchend',e=>{const diff=startX-e.changedTouches[0].clientX;if(Math.abs(diff)>40)show(current+(diff>0?1:-1));});
 const videos=[...root.querySelectorAll('video')];const observer=new IntersectionObserver(entries=>entries.forEach(e=>{if(e.isIntersecting){e.target.muted=true;e.target.play().catch(()=>{});}else e.target.pause();}),{threshold:.15});videos.forEach(v=>observer.observe(v));
 const slider=root.querySelector('#ltpVideoSlider'),nav=root.querySelector('#ltpVideoDots');if(slider&&nav){const frames=[...slider.children];frames.forEach((frame,i)=>{const b=document.createElement('button');b.type='button';b.setAttribute('aria-label',root.dataset.slideLabel+' '+(i+1));b.setAttribute('aria-current',String(i===0));b.addEventListener('click',()=>slider.scrollTo({left:frame.offsetLeft,behavior:'smooth'}));nav.append(b);});slider.addEventListener('scroll',()=>{let closest=0;frames.forEach((f,i)=>{if(Math.abs(f.offsetLeft-slider.scrollLeft)<Math.abs(frames[closest].offsetLeft-slider.scrollLeft))closest=i;});[...nav.children].forEach((b,i)=>b.setAttribute('aria-current',String(i===closest)));},{passive:true});}
}
document.querySelectorAll('.lure-presell').forEach(initLurePresell);
document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('.lure-presell').forEach(initLurePresell));


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lure-videos"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[id^="LureVideos-"]');
    roots.forEach((root) => {
      if (root.dataset.ready === 'true') return;
      const slider = root.querySelector('[data-slider]');
      const dots = root.querySelector('[data-dots]');
      const slides = Array.from(root.querySelectorAll('.lure-videos__frame'));
      if (!slider || !dots || !slides.length) return;
      root.dataset.ready = 'true';
      const setActive = (activeIndex) => {
        dots.querySelectorAll('button').forEach((dot, index) => {
          if (index === activeIndex) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      };
      slides.forEach((slide, index) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.setAttribute('aria-label', `${index + 1}`);
        if (index === 0) button.setAttribute('aria-current', 'true');
        button.addEventListener('click', () => slide.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' }));
        dots.appendChild(button);
      });
      const observer = new IntersectionObserver((entries) => {
        let best = { index: 0, ratio: 0 };
        entries.forEach((entry) => {
          const index = slides.indexOf(entry.target);
          if (entry.intersectionRatio > best.ratio) best = { index, ratio: entry.intersectionRatio };
        });
        setActive(best.index);
      }, { root: slider, threshold: [.5, .75, .9] });
      slides.forEach((slide) => observer.observe(slide));
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
